"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
var _labelConsts = require("../../constants/labelConsts");
var _sendLog = require("../../logics/sendLog");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const StyledErrorText = (0, _styles.styled)(_Typography.default)(_ref => {
  var _theme$palette$infoma;
  let {
    theme
  } = _ref;
  return {
    color: (_theme$palette$infoma = theme.palette.infomation) === null || _theme$palette$infoma === void 0 ? void 0 : _theme$palette$infoma.secondary,
    fontWeight: 'bold',
    fontSize: theme.typography.fontSize * 1.23,
    marginTop: theme.spacing(2)
  };
});

/**
 * システムエラー画面
 */
class SystemError extends _react.default.Component {
  componentDidMount() {
    const {
      sessionId,
      boundaryError
    } = this.props;
    (0, _sendLog.sendErrorLog)(sessionId, 'Boundary Error', boundaryError.error);
  }
  render() {
    const {
      intl
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(StyledErrorText, {
      align: "left"
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_SYSTEM_ERROR_PAGE_MESSAGE
    }).split('\n').map((line, key) => /*#__PURE__*/_react.default.createElement("span", {
      key: key
    }, line, /*#__PURE__*/_react.default.createElement("br", null)))), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      align: "left"
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_ERROR_OCCURED_TIME
    }, {
      0: (0, _moment.default)().format(intl.formatMessage({
        id: _labelConsts.LABEL.CORE_DATETIME_FORMAT
      }))
    })));
  }
}
const mapStateToProps = state => {
  return {
    sessionId: state.coreLoginInfo.sessionId
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactIntl.injectIntl)(SystemError));